module.exports = __webpack_public_path__ + "assets/img/project-blob-left.9dc9b1c1.png";